import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { MojoPrivilegesService } from 'mojo-privileges';
import { Observable, of } from 'rxjs';
import { first, map } from 'rxjs/operators';
import { isModalConfirmed, ModalShow } from '@shared/modal';
import { AddEditTalentPoolComponent } from '@modules/talent-pools-page/components/add-edit-talent-pool/add-edit-talent-pool.component';
import { MojoFeatureExtensionsService } from 'mojo-feature-extensions';

@Injectable()
export class TalentPoolFormGuard {
  constructor(
    private privilegesService: MojoPrivilegesService,
    private featureExtensionService: MojoFeatureExtensionsService,
    private store: Store<{}>,
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    const privilege = route.data.privilege;
    const excludedFE = route.data.excludedFeatureExtension;
    const hasPrivilege = this.privilegesService.hasPrivilege(privilege);
    const excludedExtensionIsOff = this.featureExtensionService
      .hasFeatureExtension(excludedFE)
      .pipe(map((hasExtension) => !hasExtension));
    return excludedFE ? hasPrivilege && excludedExtensionIsOff : hasPrivilege;
  }

  canDeactivate(component: AddEditTalentPoolComponent): Observable<boolean> {
    if (component.canDeactivate()) {
      return of(true);
    }
    this.store.dispatch(
      new ModalShow({
        title: 'Are you sure you want to leave this page?',
        message: 'All unsaved changes will be lost.',
      }),
    );
    return this.store.select(isModalConfirmed).pipe(first((confirmed) => !!confirmed));
  }
}
